import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../Baseurl";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Register = () => {
  const [organizationName, setOrganizationName] = useState("");
  const [employeeSize, setEmployeeSize] = useState("");
  const [fullName, setFullName] = useState("");
  const [designation, setDesignation] = useState("");
  const [phone, setPhone] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  setLoading(true); // Start loader

  // Prepare the data to send
  const formData = {
    organizationName,
    employeeSize,
    fullName,
    designation,
    phone,
    website,
    email,
    password,
  };

  console.log("🔵 Admin Registration Data Sent:", formData);

  try {
    const response = await axios.post(`${baseurl}createOrganizationAndUser`, formData);
    console.log("✅ Registration Success:", response.data);

    toast.success('Organization and user created successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    navigate(`/?email=${encodeURIComponent(email)}`);
  } catch (error) {
    console.error("❌ Registration Error:", error.response ? error.response.data : error.message);

    const errorMessage = error.response?.data?.message || 'Registration failed. Please try again.';
    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } finally {
    setLoading(false); // Stop loader
  }
};





  return (
    <div className="my-5">
      <div className="container d-flex justify-content-center align-items-center">
        <div>
          {/* Logo SVG */}
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="50" viewBox="0 0 200.39 112.97" className="mx-auto">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path d="M199.54,103.9l-60.27-101a6,6,0,0,0-8.87-1.64L2.3,102.26A6,6,0,0,0,6,113H28.33a6,6,0,0,0,3.72-1.29l91.24-71.9a6,6,0,0,1,8.86,1.64L154,78.06a6,6,0,0,1-5.16,9.08H121.13a6,6,0,0,0-3.69,1.26L99.68,102.24A6,6,0,0,0,103.37,113h91A6,6,0,0,0,199.54,103.9Z"></path>
              </g>
            </g>
          </svg>

          <div className="mb-3">
            <h3 className="text-dark">Create Your Account</h3>
            <p className="text-muted">Please register to continue</p>
          </div>

          <div className="card p-4" style={{ maxWidth: "400px", width: "100%" }}>
            <form onSubmit={handleSubmit}>
              {/* Organization Name */}
              <div className="mb-3 text-start">
                <label className="form-label">organization Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Organization Name"
                  value={organizationName}
                  onChange={(e) => setOrganizationName(e.target.value)}
                  required
                />
              </div>

              {/* Employee Size Dropdown */}
              <div className="mb-3 text-start">
                <label className="form-label">Employee Size <span className="text-danger">*</span></label>
                <select
                  className="form-select"
                  value={employeeSize}
                  onChange={(e) => setEmployeeSize(e.target.value)}
                  required
                >
                  <option value="">Select Employee Size</option>
                  <option value="1-10">1-10</option>
                  <option value="11-50">11-50</option>
                  <option value="51-200">51-200</option>
                  <option value="201-500">201-500</option>
                  <option value="501-1000">501-1000</option>
                  <option value="1000+">1000+</option>
                </select>
              </div>

              {/* Full Name */}
              <div className="mb-3 text-start">
                <label className="form-label">Full Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </div>

              {/* Designation */}
              <div className="mb-3 text-start">
                <label className="form-label">Job Role <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Job Role"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  required
                />
              </div>

              {/* Phone Number */}
              <div className="mb-3 text-start">
                <label className="form-label">Phone Number <span className="text-danger">*</span></label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter Your Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>

              {/* Website (optional) */}
              {/* <div className="mb-3 text-start">
                <label className="form-label">Website URL (optional)</label>
                <input
                  type="url"
                  className="form-control"
                  placeholder="https://yourwebsite.com"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </div> */}

              {/* Email */}
              <div className="mb-3 text-start">
                <label className="form-label">Email Address <span className="text-danger">*</span></label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {/* Password */}
              <div className="mb-3 text-start">
                <label className="form-label">Password <span className="text-danger">*</span></label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter Your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <div
                    className="pwhide"
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div className="mt-3">
  <button type="submit" className="btn btn-primary w-100" disabled={loading}>
    {loading ? (
      <>
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Signing Up...
      </>
    ) : (
      "Sign Up"
    )}
  </button>
</div>


              <p className="mt-3 text-center text-muted" style={{ fontSize: "14px" }}>
                Already have an account? <a href="/" className="text-primary">Login</a>
              </p>

            </form>
          </div>

        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Register;
